import { css } from '@emotion/react';
import styled from '@emotion/styled';
import {
    colors,
    colorVariables,
    fontSizes,
    fontWeights,
    gutterSizes,
    lineHeights,
    mediaQuery,
    breakpoints,
    zIndexes,
} from '@gumtree/ui-library/src/base/theme';

const maskBorderWidth = 12;

export const StyledWrapper = styled.div<{ mobile?: boolean }>`
    position: relative;
    display: none;

    height: 42px;
    align-items: flex-end;

    &.opened {
        background: ${colorVariables.textNeutral};
    }

    ${({ mobile }) => {
        return mobile
            ? `${mediaQuery.until(breakpoints.medium)} {
            display: flex;
        }`
            : `${mediaQuery.from(breakpoints.medium)} {
            display: flex;
        }`;
    }}
`;

export const StyledButton = styled.div`
    cursor: pointer;
    .avatar {
        background-color: ${colors.surface};
        color: ${colors.fgButtonDisabled};
        font-weight: ${fontWeights.bold};
        font-size: ${fontSizes.medium};
    }

    .opened & {
        &:after {
            content: '';
            display: block;
            border: ${maskBorderWidth}px solid ${colorVariables.textNeutral};
            border-style: solid;
            height: 100%;
            width: 100%;
            position: absolute;
            transform: translate(-50%, -50%);
            top: 50%;
            left: 50%;
        }
    }
`;

export const StyledAccountMenuWrapper = styled.div<{ isOpen?: boolean }>`
    display: flex;
    background-color: ${colors.darkGrey};
    flex-direction: column;
    gap: ${gutterSizes.large};
    align-items: flex-start;
    padding: ${gutterSizes.medium10} ${gutterSizes.xlarge};
    position: absolute;
    top: 50px;
    right: -${maskBorderWidth}px;
    min-width: 200px;
    max-width: 400px;
    z-index: ${({ isOpen }) => (isOpen ? zIndexes.high + 2 : zIndexes.low)};

    /* slide-in animation */
    will-change: auto;
    opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
    visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
    transform: translateY(${({ isOpen }) => (isOpen ? '0' : '-10px')});
    transition: all 0.4s ease;
`;

export const StyledProfileSection = styled.div`
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    gap: ${gutterSizes.base};
`;

export const StyledAvatar = styled.div`
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background-color: ${colors.surface};
    border: 2px solid ${colors.newGrey};
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    .avatar {
        background-color: ${colors.surface};
        color: ${colors.fgButtonDisabled};
        font-size: ${fontSizes.base};
        font-weight: ${fontWeights.bold};
    }
`;

export const StyledUserName = styled.span`
    flex: 1;
    min-width: 0;
    font-size: ${fontSizes.header};
    font-weight: ${fontWeights.bold};
    line-height: ${lineHeights.base24};
    color: ${colors.white};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const StyledAccountsList = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${gutterSizes.large};
    width: 100%;
`;

export const StyledAccountItem = styled.div<{ isSelected?: boolean }>`
    display: flex;
    gap: 6px;
    height: 24px;
    align-items: center;
    justify-content: center;
    width: 100%;
    cursor: pointer;

    &:hover {
        opacity: 0.8;
    }
`;

export const StyledAccountName = styled.span`
    flex: 1;
    font-size: ${fontSizes.base};
    font-weight: ${fontWeights.bold};
    line-height: ${lineHeights.base};
    color: ${colors.white};
    letter-spacing: 0.15px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const StyledCheckIcon = styled.div<{ isSelected?: boolean }>`
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    visibility: hidden;

    ${({ isSelected }) => isSelected && css`
        visibility: visible;
    `}

    svg {
        width: 16px;
        height: 12px;
    }
`;

export const StyledMobileMenuContent = styled.div`
    width: 270px;
    height: 100vh;
    overflow-y: auto;
    background-color: ${colors.darkGrey};
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    gap: ${gutterSizes.large};
    padding: ${gutterSizes.large} 0 ${gutterSizes.large} ${gutterSizes.xlarge};
    box-sizing: border-box;

    position: fixed;
    top: 0;
    right: 0;
    z-index: ${zIndexes.high + 2};

    ${StyledProfileSection} {
        padding-right: ${gutterSizes.xlarge};
    }

    ${StyledAccountsList} {
        flex: 1;
        padding-right: ${gutterSizes.xlarge};
        box-sizing: border-box;
        overflow-y: auto;
    }
`;
